export const CAS_LANGUAGE_LOCAL_STORAGE_KEY = 'ngStorage-casLanguage'

export const INVERT_COLORS = 'invert-colors'
export const INIT_LOCALE_MODAL_DISMISSED = 'init-locale-modal-dismissed'

export const LANGUAGE_ENGLISH = 'en'

export const THEME_CLASSIC = 'theme-classic'
export const THEME_INVERTED = 'theme-inverted'

export const HELP_DOCSET_ALIAS = 'helpcenterhelp'
export const HELP_DOCSET_CFR = '2.0'
export const HELP_DOCSET_PAGE_NOT_FOUND = 'nocdcfound.htm'
export const HELP_DOCSET_UNAUTHORIZED = 'unauthorized.htm'

export const WELCOME_DOCSET_ALIAS = 'helpcenterwlcm'
export const WELCOME_DOCSET_CFR = '1.0'
export const WELCOME_DOCSET_PAGE = 'home.htm'
export const WELCOME_PAGE_CSS = 'help-center-landingPage-00'

export const DOCSET_PAGE_TITLEPAGE = 'titlepage.htm'

export const MEDIA_DEVICE_SMALL = '(max-width: 761px)'

export const VERSION_GROUP_VIYA4 = 'Viya4'

export const VERSION_LTS_IND = "LTS"

export const DOCSET_LATEST_CFR = "latest"

export const BANNER_UNAVAILABLE_KEY = 'unavailable_key'
export const BANNER_UNSUPPORTED_KEY = 'unsupported_key'